<template>
	<div>
		<!-- If modal have a "pui-select" or "pui-date-field", set property :overflow="false" -->
		<!-- If fixed width is needed, set property :widthDialog="XXX" -->
		<pui-modal-dialog-form
			:titleText="$t('modal.distressalertssitrep.sample.title')"
			:modelName="modelName"
			:dialogName="distressalertssitrepSampleModal"
			:componentHeaderName="'distressalertssitrep-form-header'"
			:onOk="onOkSampleModal"
			:onShow="onShowSampleModal"
		>
			<template slot="message" slot-scope="data">
				<v-row dense>
					<!-- SITREPNUMBER -->

					<v-col cols="12">
						<pui-text-field
							:id="`sitrepnumber-distressalertssitrep`"
							v-model="data.modalData.sitrepnumber"
							:label="$t('distressalertssitrep.sitrepnumber')"
							:disabled="formDisabled"
							required
							toplabel
						></pui-text-field>
					</v-col>
				</v-row>
			</template>
		</pui-modal-dialog-form>
	</div>
</template>

<script>
export default {
	name: 'distressalertssitrep-modals',
	data() {
		return {
			distressalertssitrepSampleModal: 'distressalertssitrepSampleAction'
		};
	},
	props: {
		modelName: {
			required: true,
			type: String
		}
	},
	methods: {
		onOkSampleModal(modalData) {
			const params = {
				attr1: modalData.field1
			};

			const url = this.$store.getters.getModelByName(this.modelName).url.sampleUrl;
			var title = this.$puiI18n.t('puiaction.notifyTitle') + ' > ' + this.$puiI18n.t('modal.distressalertssitrep.sampleaction.title');
			return new Promise((resolve) => {
				this.$puiRequests.postRequest(
					url,
					null,
					() => {
						// Valid response, do code and close modal
						resolve(true);
					},
					(e) => {
						// Error response, do code and not close modal
						let message = this.$puiI18n.t('puiaction.notifyError');
						if (e.response && e.response.data) {
							message = e.response.data.message;
						}
						this.$puiEvents.$emit('onPui-action-running-ended-' + this.modelName);
						this.$puiNotify.error(message, title);
						resolve(false);
					},
					null,
					params
				);
			});
		},
		onShowSampleModal() {
			// Put here code to execute before open modal.
			// Examples:
			// - Watch pui-select/pui-datatable with events
			// - change values or set new values "this.$set(modalData,'field3', null)"
			// ...
		}
	}
};
</script>
